import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { i18n } from "./utils/i18n";
import Toast from "./components/Toast";
import VueLazyload from 'vue-lazyload';
import loadingImg from "@/assets/images/default_cover.png";
import "./assets/svgIcon/svg.font.js"
import Loading from "./components/Loading/loading.js"
import "./utils/log.js"
import exposureDirective from "./utils/directives/exposure.js"

Vue.use(VueLazyload, {
  //预加载高度
  preLoad: 1.3,
  //错误时显示的图片
  error: loadingImg,
  //图片加载中显示的图片
  loading: loadingImg,
  //尝试加载次数
  attempt: 1
});

Vue.config.productionTip = false;

Vue.use(Toast)
Vue.use(Loading)
Vue.directive('exposure', exposureDirective)
Vue.use(VueLazyload, {
  observerOptions: {
    rootMargin: "100px",
    threshold: 0.1,
  },
});

const browserLang = window.navigator?.language?.split?.(',')?.[0]?.split?.('-')?.[0]
store.dispatch('common/setLang', store.state.common.lang || browserLang)

store.dispatch('common/initLaunchParams')
store.dispatch('common/login')

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
